import { LiteralTypeEnum, OperatorEnum, VariableTypeEnum } from './types'

// The literal type is determined at runtime, based on the variable type and the comparison operator
// When operator is 'one_of' or 'not_one_of', we use integer_array (for entities) or string_array (for enums)
// When operator is 'contains' or 'not_contains', we use string type (checking if array contains a string value)
export const getLiteralType = (
  variableType?: VariableTypeEnum,
  operator?: OperatorEnum,
  isEnumVariable?: boolean
): LiteralTypeEnum => {
  if (operator === 'one_of' || operator === 'not_one_of') {
    return isEnumVariable ? 'string_array' : 'integer_array'
  }

  // contains/not_contains: the right-hand side is a single string value to check in the array
  if (operator === 'contains' || operator === 'not_contains') {
    return 'string'
  }

  switch (variableType) {
    case 'integer':
      return 'integer'
    case 'boolean':
      return 'boolean'
    case 'float':
    case 'money':
      return 'float'
    case 'string':
    default:
      return 'string'
  }
}
